import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import { useSupabaseAuth } from '../hooks/useSupabaseAuth';
import { applyReferralCode } from '../lib/api';
// import { fetchEntitlements } from '../lib/entitlements';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const { user, loading, signInWithGoogle, signInWithEmail, signOut } = useSupabaseAuth();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  // Temporarily disable paywall - all authenticated users have access
  const hasAccess = Boolean(user);
  const checkingEntitlements = false;

  // useEffect(() => {
  //   let mounted = true;

  //   const loadEntitlements = async () => {
  //     if (!user?.id) {
  //       setHasAccess(false);
  //       return;
  //     }
  //     setCheckingEntitlements(true);
  //     const { hasAccess: access } = await fetchEntitlements(user.id);
  //     if (!mounted) return;
  //     setHasAccess(access);
  //     setCheckingEntitlements(false);
  //   };

  //   loadEntitlements();

  //   return () => {
  //     mounted = false;
  //   };
  // }, [user?.id]);

  const referralAppliedRef = useRef(false);

  useEffect(() => {
    if (user) {
      setAuthModalOpen(false);
    }
  }, [user]);

  // Auto-apply referral code from localStorage after sign-in
  useEffect(() => {
    if (!user || referralAppliedRef.current) return;
    referralAppliedRef.current = true;

    const refCode = localStorage.getItem('latted_referral_code');
    if (!refCode) return;

    applyReferralCode(refCode)
      .then((result) => {
        if (result.applied) {
          localStorage.setItem('latted_referral_applied', 'true');
        }
        localStorage.removeItem('latted_referral_code');
      })
      .catch(() => {
        localStorage.removeItem('latted_referral_code');
      });
  }, [user]);

  const openAuthModal = useCallback(() => {
    if (loading || user) return;
    setAuthModalOpen(true);
  }, [loading, user]);
  const closeAuthModal = useCallback(() => setAuthModalOpen(false), []);

  const value = useMemo(
    () => ({
      user,
      loading,
      hasAccess,
      checkingEntitlements,
      authModalOpen,
      openAuthModal,
      closeAuthModal,
      signInWithGoogle,
      signInWithEmail,
      signOut,
      supabase,
    }),
    [authModalOpen, checkingEntitlements, closeAuthModal, hasAccess, loading, openAuthModal, signInWithEmail, signInWithGoogle, signOut, user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuthContext must be used within AuthProvider');
  }
  return context;
}
